function enrichPlanningSelection(item, kind, filters, datasets) {
  const standards = datasets.standards?.items || []
  const expectations = datasets.expectations?.items || []
  const parent = kind === 'indicator'
    ? expectations.find(expectation => expectation.id === item.expectation || (expectation.indicators || []).some(indicator => indicator.id === item.id))
    : item
  const standard = standards.find(entry => entry.id === (parent?.standard || filters.standard))
  const metadata = {
    standard: parent?.standard || filters.standard,
    standard_name: standard?.name,
    expectation_name: parent?.name,
    expectation_description: parent?.description
  }
  if (kind === 'expectation' && Array.isArray(item.indicators)) {
    return {...item, ...metadata, indicators:item.indicators.map(indicator => ({...indicator, ...metadata}))}
  }
  return {...item, ...metadata}
}
module.exports = {enrichPlanningSelection}
